import styles from "./UserAvatar.module.scss";
import { clsx } from "clsx";
import { useHomeContextUser } from "../homeContext.ts";

export const Account = () => {
  return (
    <svg aria-hidden="true" focusable="false" width={22} height={27}>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M18.332 16.68c-.385-.2-1.928-1.202-2.508-.602-.77.801-2.896 2.602-4.824 2.602-1.93 0-4.05-1.8-4.824-2.602-.58-.6-2.123.402-2.51.602-1.158.799-1.35.998-2.313 2.202-.58.6-.968 1.401-1.353 2 2.508 3.607 6.561 6.007 11 6.007 4.631 0 8.684-2.4 11-6.006-.388-.6-.773-1.401-1.35-2-.773-1.005-1.16-1.404-2.318-2.203M17.111 6.948c0 3.858-3.055 7.719-6.111 7.719-3.056 0-6.111-4.053-6.111-7.719C4.889 3.28 7.563 0 11 0c3.44 0 6.111 3.088 6.111 6.948" />
        <path d="M4.889 6.948c0 3.666 3.055 7.719 6.111 7.719 3.056 0 6.111-3.86 6.111-7.719C17.111 3.088 14.44 0 11 0 7.56 0 4.889 3.283 4.889 6.948z" />
      </g>
    </svg>
  );
};

export default function UserAvatar({ className }: { className?: string }) {
  const user = useHomeContextUser();
  const firstInitial = user.ssoOnly ? "" : user.firstName?.charAt(0);

  return (
    <div className={clsx(styles.container, className)} aria-hidden="true">
      {firstInitial || <Account />}
    </div>
  );
}
